import { useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { NavbarDesktop, NavbarMobile } from './Navbar'
import { LogoutModal } from './LogoutModal'
import { useCart } from './Cart/useCart'
import { useUser } from './User/useUser'

function Header({ menu }) {
    const cart = useCart()
    const user = useUser()
    const router = useRouter()
    const [searchQuery, setSearchQuery] = useState('')
    const menuItems = [
        { title: 'خانه', href: '/' },
        {
            title: 'محصولات',
            children: menu
        },
        //TODO make shallow dynamic and remove shallow
        { title: 'سوالات متداول', href: '/faq' },
        { title: 'درباره ما', href: '/about' },
        { title: 'تماس با ما', href: '/contact' }
    ]

    function performSearch(e) {
        e.preventDefault()
        if (!searchQuery) return
        setSearchQuery('')
        router.push(`/products?search=${searchQuery}`)
    }

    return (
        <section>
            <nav className="flex items-center justify-between flex-wrap bg-teal-500 p-2 main-head">
                <Link href="/">
                    <a className="flex items-center flex-shrink-0 mr-6">
                        <img className="fill-current h-14 w-14 ml-3" src="/img/logo.jpeg" />
                        <img className="w-32 ml-3" src="/img/type-2.png" />
                    </a>
                </Link>
                <div className="hidden flex-grow lg:block lg:items-center lg:w-auto mr-20">
                    <div className="text-sm flex lg:flex-grow justify-end ml-6">
                        {user.isLoggedIn && (
                            <>
                                <Link href="/profile">
                                    <button
                                        className="leftHead flex message font-bold p-2 rounded outline-none focus:outline-none mr-2 mb-1"
                                        type="button"
                                        style={{ transition: 'all .15s ease' }}>
                                        <span className="ico flaticon-199-user flex align-center justify-center"></span>
                                        <span className="mr-2">پروفایل</span>
                                    </button>
                                </Link>
                                <LogoutModal />
                            </>
                        )}
                        {!user.isLoggedIn && (
                            <>
                                <Link href="/auth/signin">
                                    <button
                                        className="leftHead flex message font-bold px-2 py-2 rounded outline-none focus:outline-none mr-2 mb-1"
                                        type="button"
                                        style={{ transition: 'all .15s ease' }}>
                                        <span className="ico flaticon-199-user flex align-center justify-center"></span>
                                        <span className="mr-2">ورود</span>
                                    </button>
                                </Link>
                                <Link href="/auth/register">
                                    <button
                                        className="leftHead flex message font-bold px-2 py-2 rounded outline-none focus:outline-none mr-2 mb-1"
                                        type="button"
                                        style={{ transition: 'all .15s ease' }}>
                                        <span className="ico flaticon-142-writing-5 flex align-center justify-center"></span>
                                        <span className="mr-2">ثبت نام </span>
                                    </button>
                                </Link>
                            </>
                        )}

                        {/* <span className='ico flaticon-142-writing-5 flex align-center justify-center'></span>
                            <span className='mr-2'></span> */}
                        <Link href="/cart">
                            <button
                                className="leftHead flex cart font-bold px-2 py-2 rounded outline-none focus:outline-none mr-2 mb-1 relative"
                                type="button"
                                style={{ transition: 'all .15s ease' }}>
                                <span className="ico flaticon-171-shopping-cart flex align-center"></span>
                                <span className="mr-2">سبد خرید</span>
                                {cart.items && cart.items.length !== 0 && (
                                    <span className="font-normal py-1 px-2 mr-2 uppercase rounded bg-gray-700">{cart.items.length}</span>
                                )}
                            </button>
                        </Link>
                    </div>
                </div>
            </nav>
            <div className="secondNav flex pt-5">
                <form onSubmit={performSearch} className="relative text-gray-600 justify-start align-center lg:mr-20 mx-auto mb-2 w-full sm:w-auto px-5">
                    <input
                        type="search"
                        name="search"
                        placeholder="جستجو"
                        className="h-10 px-5 pr-10 rounded-full text-sm focus:outline-none border border-pink-200 w-full"
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value)
                        }}
                    />
                    <button type="submit" className="absolute right-8 top-1 mt-2">
                        <img width="20" src="/img/icons/svg/022-search.svg" />
                    </button>
                </form>
                <NavbarDesktop items={menuItems} />
                <NavbarMobile />

                <ul className="hidden sm:list-none sm:flex sm:ml-10 sm:align-center sm:pb-5 sm:flex-grow sm:justify-end">
                    <li>
                        <a
                            href="https://www.instagram.com/kaajstore/"
                            className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9">
                            <img src="/img/icons/png/icons8-instagram-100.png" className="opacity-50" alt="" />
                        </a>
                    </li>
                    <li>
                        <a className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9">
                            <img src="/img/icons/png/icons8-whatsapp-100.png" className="opacity-50" alt="" />
                        </a>
                    </li>
                    <li>
                        <a className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9">
                            <img src="/img/icons/png/telegram.png" className="opacity-50" alt="" />
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export { Header }
